<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Correspondencia" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="8">
                <app-autocomplete
                    :items="clients"
                    @input="loadVenues"
                    v-model="selectedClient"
                    label="Cliente"
                />
            </b-col>
            <b-col cols="12" md="4">
                <app-form-select-input
                    :options="venues"
                    v-model="selectedVenueId"
                    label="Sede"
                ></app-form-select-input>
            </b-col>
        </b-row>

        <b-row v-if="!!selectedClient && !!selectedVenueId">
            <b-col cols="12">
                <b-tabs content-class="mt-3">
                    <b-tab title="Pendiente" active>
                        <app-deliver-form
                            :client-id="selectedClient.id"
                            :venue-id="selectedVenueId"
                        />
                    </b-tab>
                    <b-tab title="Entregada">
                        <app-delivered-mail
                            :client-id="selectedClient.id"
                            :venue-id="selectedVenueId"
                        />
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>
<script>
// import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete'
import DeliverForm from '../../Vigilance/Mail/MailPage/DeliverForm/DeliverForm'
import DeliveredMail from '../../Vigilance/Mail/MailPage/DeliveredMail/DeliveredMail'
import { mapGetters } from 'vuex'
export default {
    components: {
        appDeliverForm: DeliverForm,
        appDeliveredMail: DeliveredMail,
    },
    data: () => ({
        selectedClient: '',
        selectedVenueId: '',
        venues: [],
    }),
    computed: {
        ...mapGetters(['clients']),
    },
    methods: {
        // async loadClients() {
        //     const { data } = await repo.get('clients/list')
        //     this.clients = data
        // },
        async loadVenues(client) {
            this.venues = []
            this.selectedVenueId = ''
            const { data } = await repo.get('venues', {
                client: client.id,
            })
            this.venues = data
        },
    },
    created() {
        // this.loadClients()
        this.load('clients')
    },
}
</script>
